export const MANUAL_ANOMALIES_CONTEXT_COLUMN_FIELDS: string[] = [
  'stageTypeId',
  'wellboreTypeId',
  'trajectoryTypeId',
  'sectionTypeId',
  'holeType',
  'stratUnitTypeId',
  'reservoirId',
  'runTypeId',
  'operationTypeId',
] as const;
